/**
 *  ・クラス名
 *    売粗データエクスポート用モデル
 *  ・概要
 *    売粗データエクスポート画面で使用するmodelファイル
 *  ・更新履歴
 *    2022/07/07 新規作成 野口
 */
import BaseModel from './baseModel';
import ServiceType from '@/models/data/serviceType';
import Customer from '@/models/data/customer';
import Company from '@/models/data/company';
import Employee from '@/models/data/employee';
import Commodity from '@/models/data/commodity';
import Supplier from '@/models/data/supplier';

export default class DataExportModel extends BaseModel {
  private serviceType = new ServiceType();
  private customer = new Customer();
  private company = new Company();
  private employee = new Employee();
  private commodity = new Commodity();
  private supplier = new Supplier();

  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  constructor() {
    super();
  }

  /**
   * 各種入力フォームで使用する各マスタ情報を取得
   * プロパティーに格納します
   * @param none
   * @returns void
   */
  public async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
    [
      mData['m_service_type'],
      mData['m_customer'],
      mData['m_company'],
      mData['m_employee'],
      mData['m_commodity'],
      mData['m_supplier']
    ] = await Promise.all([
      this.serviceType.getFormatData(),
      this.customer.getFormatData(),
      this.company.getFormatData(),
      this.employee.getFormatData(),
      this.commodity.getFormatData(),
      this.supplier.getFormatData()
    ]);
    this.masterData = mData;
    return this.masterData;
  }

  /**
   * マスタ情報を取得します
   * @returns {array} - マスタ情報配列
   */
  public getMaster() {
    return this.masterData;
  }

  /**
   * 指定データストアのフィールド情報を取得します
   * @returns {array} - フィールド情報配列
   */
  public getField(appId: string, dId: string) {
    return this.getFieldsData(appId, dId).then(data => data);
  }

  /**
   * formのdisplay_idとchangeFormItemのdisplay_idが一致する場合にlabelTextを変更
   * @param form - フォーム情報
   * @param changeFormItem - formのdisplay_idと一致する内容がある場合にlabelTextを変更するアイテム
   */
   public changeFormLabel(form:Array<any>, changeFormItem:any) {
    for (const item of form) {
      const data = changeFormItem.find((data:any) => item.display_id === data.display_id)
      if (data !== undefined) {
        data.props!.labelText = item.props.labelText;
        data.props!.name = item.props.name;
      }
    }
  }

  /**
   * 出力条件(日付)の書式設定
   */
  public dateToDbDatetime(dateValue: string) {
    return dateValue ? (dateValue.replace(/\//g, "-") + "T00:00:00.000Z") : "";
  };
  public dateToDbDatetimeEnd(dateValue: string) {
    return dateValue ? (dateValue.replace(/\//g, "-") + "T23:59:59.999Z") : "";
  };

  /**
   * JSON形式で取得したデータレポートをCSV出力用に変換
   * @param apiResponseData - データレポートレスポンス
   */
    public sellingConvertCsv(apiResponseData: { [key: string]: any }) {
      const titles: string[] = [];
      const displayIds: string[] = [];
      const reportFields = apiResponseData['report_fields'];
      const reportResults = apiResponseData['report_results'];

      // ヘッダ情報とdisplay_idを取得
      Object.keys(reportFields).forEach(key => {
        if(!reportFields[key]['hide']) {
          titles.push(reportFields[key]['title']);
          displayIds.push(reportFields[key]['display_id']);
        }
      });
      const header = titles.join(',') + "\n";
      let body = "";

      // データ部分変換処理
      Object.keys(reportResults).forEach(key => {
        const data: string[] = [];
        for(const index in displayIds) {
          switch(displayIds[index]) {
            case 'expected_sales_date':
            case 'project_completion_date':
              if(reportResults[key][displayIds[index]] !== undefined) {
                  data.push(this.editDatetype(reportResults[key][displayIds[index]], 'Asia/Tokyo', 'yyyy/MM/dd'))
              } else {
                  data.push("");
              }
              break;

            case 'division':
              if (reportResults[key].lookup_items !== undefined) {
                if(reportResults[key].lookup_items.manager_id !== undefined) {
                  data.push(reportResults[key].lookup_items.manager_id.division);
                } else {
                  data.push("");
                }  
              }
              break;

            default:
              if(reportResults[key][displayIds[index]] !== undefined) {
                  data.push(reportResults[key][displayIds[index]])
              } else {
                  data.push("");
              }
              break;
          }
        }
        body = body + data.join(',') + "\n";
      });

      return header + body;
    }
}
